/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXyVUpIcon16Light = forwardRef('DataChartBarsXyVUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 1.5a.5.5 0 0 0-1 0V12a2 2 0 0 0 2 2h11.5a.5.5 0 0 0 0-1H3a1 1 0 0 1-1-1V1.5Z" }),
        React.createElement("path", { d: "M13.5 1a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M11 3.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Z" }),
        React.createElement("path", { d: "M7.5 5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M4.5 7a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5Z" })));
});
